import { c as _c } from "react/compiler-runtime";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { WAVE_VOTE_STATS_LABELS, WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
import type { RatingsSectionProps, RatingsData } from "./types";
interface ParticipationDropRatingsUserSectionProps extends RatingsSectionProps {
  readonly ratingsData: RatingsData;
  readonly drop: ApiDrop;
}
export default function ParticipationDropRatingsUserSection(t0) {
  const $ = _c(8);
  const {
    drop,
    ratingsData
  } = t0;
  const {
    userRating
  } = ratingsData;
  const userValueClass = userRating < 0 ? "tw-text-rose-400" : "tw-text-iron-50";
  if (userRating === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-font-normal tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:{" "}</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `tw-font-medium ${userValueClass}`;
  const t3 = userRating < 0 && "-";
  let t4;
  if ($[1] !== userRating) {
    t4 = formatNumberWithCommas(Math.abs(userRating));
    $[1] = userRating;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = WAVE_VOTING_LABELS[drop.wave.voting_credit_type];
  let t6;
  if ($[3] !== t2 || $[4] !== t3 || $[5] !== t4 || $[6] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-leading-5"><span className="tw-whitespace-nowrap">{t1}<span className={t2}>{t3}{t4}{" "}{t5}</span></span></div>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}